import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import {reducer as reduxAsyncConnect} from 'redux-async-connect'
import {
  searchReducer as search,
  shareClassReducer as shareClass,
  familyShareClassReducer as familyShareClass,
  tutorialdismissReducer as tutorialdismiss,
  companyReducer as company,
  compareReducer as compare,
  cartReducer as cart,
  fundsByStrategyReducer as fundsByStrategy
} from './search'

export default combineReducers({
  routing: routerReducer,
  reduxAsyncConnect,// ,
  search,
  shareClass,
  familyShareClass,
  tutorialdismiss,
  company,
  compare,
  cart,
  fundsByStrategy
})
